import { IconName, MaybeElement, MenuItem, Tooltip } from '@blueprintjs/core';

type IActionsMenuButton = {
  isDisabled?: boolean;
  icon: IconName | MaybeElement;
  text: string;
  tooltip?: string;
  onClick: () => void;
};

export function ActionsMenuButton({
  isDisabled,
  icon,
  text,
  onClick,
  tooltip = '',
}: IActionsMenuButton) {
  return (
    <Tooltip disabled={!isDisabled} content={tooltip} fill>
      <MenuItem
        disabled={isDisabled}
        text={text}
        icon={icon}
        onClick={onClick}
        shouldDismissPopover={false}
      />
    </Tooltip>
  );
}
